import Overlay from '@/features/common/components/Overlay'
import { useOverlay } from '@/features/pos/components/OrderFinalization/contexts/OverlayProvider'
import { FC } from 'react'

const OrderFinalizationOverlay: FC = () => {
    const overlay = useOverlay()

    if (!overlay) return null

    return <Overlay type={overlay.type} message={overlay.message} />
}

export default OrderFinalizationOverlay
